var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_8191558",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-gallery-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.445 7.61-1.2 8.58c-.26 1.8-1.25 2.75-2.88 2.75-.13 0-.26-.01-.4-.02a3.73 3.73 0 0 0 .04-.59v-8.67a2.357 2.357 0 0 0 -2.67-2.66h-9.97c0-.02.01-.05.01-.07l.24-1.68a3.242 3.242 0 0 1 1.13-2.23 3.26 3.26 0 0 1 2.455-.47l10.56 1.48a3.247 3.247 0 0 1 2.22 1.14 3.148 3.148 0 0 1 .465 2.44z",
    fill: "#396ce8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 18.333v-8.668a2.357 2.357 0 0 1 2.667-2.665h10.668a2.358 2.358 0 0 1 2.665 2.665v8.668a2.358 2.358 0 0 1 -2.665 2.667h-10.668a2.357 2.357 0 0 1 -2.667-2.667z",
    fill: "#396ce8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 13.25h-1.75v-1.75a.75.75 0 0 0 -1.5 0v1.75h-1.75a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75h1.75a.75.75 0 0 0 0-1.5z",
    fill: "#396ce8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.644faa39127918bb2f6464501d7f260b.svg";
export { ForwardRef as ReactComponent };